var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 40,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "div",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v("Copy Quote")]),
          ]
        ),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Copy to")]),
          _c(
            "div",
            { staticClass: "pretty p-default p-round p-bigger p-smooth" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.copyQuoteType,
                    expression: "copyQuoteType",
                  },
                ],
                attrs: { type: "radio", id: "newQuote" },
                domProps: { value: 0, checked: _vm._q(_vm.copyQuoteType, 0) },
                on: {
                  change: function ($event) {
                    _vm.copyQuoteType = 0
                  },
                },
              }),
              _c("div", { staticClass: "state p-primary-o" }, [
                _c("label", [_vm._v("New Quote")]),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "pretty p-default p-round p-bigger p-smooth" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.copyQuoteType,
                    expression: "copyQuoteType",
                  },
                ],
                attrs: { type: "radio", id: "existingQuote" },
                domProps: { value: 1, checked: _vm._q(_vm.copyQuoteType, 1) },
                on: {
                  change: function ($event) {
                    _vm.copyQuoteType = 1
                  },
                },
              }),
              _c("div", { staticClass: "state p-primary-o" }, [
                _c("label", [_vm._v("Existing Quote")]),
              ]),
            ]
          ),
        ]),
        _vm.copyQuoteType === _vm.copyQuoteTypes.Existing
          ? _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "is-divider" }),
              _c("div", { staticClass: "field" }, [
                _vm.copyQuoteType === _vm.copyQuoteTypes.Existing
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quoteNo,
                          expression: "quoteNo",
                        },
                        { name: "focus-inserted", rawName: "v-focus-inserted" },
                      ],
                      staticClass: "input",
                      attrs: { type: "text", placeholder: "Quote No." },
                      domProps: { value: _vm.quoteNo },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.quoteNo = $event.target.value
                          },
                          _vm.searchQuote,
                        ],
                      },
                    })
                  : _vm._e(),
                _vm.validQuote &&
                _vm.copyQuoteType === _vm.copyQuoteTypes.Existing
                  ? _c("span", { staticClass: "help is-success" }, [
                      _vm._v("Valid Quote No."),
                    ])
                  : _vm.quoteNo &&
                    _vm.copyQuoteType === _vm.copyQuoteTypes.Existing
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Invalid Quote No."),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c(
                    "div",
                    { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.isOverwrite,
                            expression: "isOverwrite",
                          },
                        ],
                        attrs: { id: "chk-overwrite-quote", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.isOverwrite)
                            ? _vm._i(_vm.isOverwrite, null) > -1
                            : _vm.isOverwrite,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.isOverwrite,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.isOverwrite = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.isOverwrite = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.isOverwrite = $$c
                            }
                          },
                        },
                      }),
                      _c("div", { staticClass: "state p-primary" }, [
                        _c("i", { staticClass: "icon mdi mdi-check" }),
                        _c("label", [_vm._v("Overwrite")]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.imageIds.length > 0
          ? _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c(
                  "div",
                  { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.isCopyImages,
                          expression: "isCopyImages",
                        },
                      ],
                      attrs: { id: "chk-copyImages", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.isCopyImages)
                          ? _vm._i(_vm.isCopyImages, null) > -1
                          : _vm.isCopyImages,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.isCopyImages,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.isCopyImages = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.isCopyImages = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.isCopyImages = $$c
                          }
                        },
                      },
                    }),
                    _c("div", { staticClass: "state p-primary" }, [
                      _c("i", { staticClass: "icon mdi mdi-check" }),
                      _c("label", [_vm._v("Copy Images")]),
                    ]),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "footer",
        {
          staticClass: "modal-card-foot",
          style: `justify-content: flex-${_vm.buttonLocation}`,
        },
        [
          _c(
            "button",
            {
              staticClass: "button is-success tooltip",
              attrs: {
                "data-tooltip": "Start copy",
                disabled:
                  _vm.copyDisabled ||
                  (!_vm.validQuote &&
                    _vm.copyQuoteType === _vm.copyQuoteTypes.Existing),
              },
              on: {
                click: function ($event) {
                  return _vm.copy()
                },
              },
            },
            [
              _c("span", { staticClass: "icon is-small" }, [
                _c("i", { staticClass: "mdi mdi-18px mdi-content-copy" }),
              ]),
              _c("span", [_vm._v("Copy")]),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "button tooltip",
              attrs: { "data-tooltip": "Cancel", disabled: _vm.cancelDisabled },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }